<template>
  <nav-bar title="钢瓶录入" />
  <Content :bottom="76">
    <RoleName role="钢瓶管理人员" />
    <van-form class="form" ref="form" @submit="submitValues">
      <Field
        name="gsCode"
        label="气瓶出厂编号"
        :rules="[{ required: true, message: '只能输入数字以及字母', pattern: /^[a-zA-Z0-9]+$/ }]"
        :formatter="formatter"
        @on-blur="asyncValidator"
      />
      <Field
        name="regId"
        label="登记证编号"
        :defaultValue="regId"
        :require="false"
        :formatter="formatter"
        readonly
      />
      <Picker
        label="制造单位"
        :columns="makeUnitList"
        :defaultVal="makeUnitName"
        :require="true"
        @confirm-values="changeUnit"
      />
      <Picker
        label="制造日期"
        pickerType="time"
        :defaultVal="makeDate"
        :require="true"
        @confirm-values="(value) => (makeDate = value)"
      />
      <Picker
        label="检验日期"
        pickerType="time"
        :defaultVal="checkDate"
        :require="true"
        @confirm-values="(value) => (checkDate = value)"
      />
      <Picker
        label="下次检验时间"
        pickerType="time"
        :defaultVal="nextCheckDate"
        :minDate="new Date()"
        :maxDate="new Date(2060, 0, 1)"
        :require="true"
        @confirm-values="(value) => (nextCheckDate = value)"
      />
      <Picker
        label="充装介质"
        :columns="gsMediumList"
        :defaultVal="gsGoodsName"
        :require="true"
        @confirm-values="changeMedium"
      />

      <Picker
        label="容积（L）"
        :columns="gsCapacityList"
        :defaultVal="gsCapacityName"
        :require="true"
        @confirm-values="(values) => (gsCapacity = values.value)"
      />
      <Field
        name="gsPressure"
        type="number"
        :defaultValue="gsPressure"
        label="公称压力（MPa）"
        :formatter="formatter"
      />
      <Field
        name="cyWeight"
        type="number"
        :defaultValue="cyWeight"
        label="钢瓶重量（kg）"
        :formatter="formatter"
      />
      <Picker
        label="气瓶种类"
        :columns="gsTypeList"
        :defaultVal="gsTypeName"
        :require="true"
        @confirm-values="(values) => (gsType = values.dicVal)"
      />
      <Field name="gsId" :defaultValue="gsId" label="内部编号" readonly />
      <Field
        name="gsStatus"
        :defaultValuel="gsStatus"
        label="气瓶状态"
        readonly
      />
      <Field name="tagId" :defaultValue="tagId" label="电子标签号" readonly />
      <Field name="belongUnit" label="隶属单位" />
      <Picker
        label="钢瓶属性"
        :columns="custodyTypeList"
        :defaultVal="custodyFlagName"
        :require="true"
        @confirm-values="(values) => (custodyFlag = values.dicVal)"
      />
      <Field
        v-if="custodyFlag === '2'"
        name="custodyUnit"
        :require="true"
        label="托管单位"
      />
      <van-field name="uploader" label="气瓶照片">
        <template #input>
          <van-uploader
            max-count="1"
            v-model="fileList"
            :after-read="afterRead"
          />
        </template>
      </van-field>

      <!--
      <Field name="gsModel" label="钢瓶型号" />
      <Field name="gsThickness" type="number" label="设计厚度" />
      <Field name="stRequirement" label="存储要求" />
      <Field name="trRequirement" label="运输要求" :border="false" />
      -->
    </van-form>
  </Content>
  <div class="btn-conatiner van-hairline--top">
    <van-button
      block
      type="primary"
      native-type="button"
      :loading="loading"
      :disabled="clickAble"
      loading-text="请稍后..."
      @click="handleSubmitClick"
    >
      提交
    </van-button>
  </div>
</template>

<script>
import { Notify } from 'vant'
import { reactive, toRefs, ref, computed } from 'vue'
import { useStore } from 'vuex'
import {
  cylinderAdd,
  cylinderPreAdd,
  cylinderDetail
} from '@/api/cylinderManageUserHome'
import { useGetData } from '@/hooks/useGetData'
import { useRouter } from 'vue-router'
import getImgFile from '@/utils/getImgFile'
export default {
  name: 'CylinderEntry', // 钢瓶录入
  setup() {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    // 获取下拉选择值
    const selectValues = reactive({
      gsMediumList: [],
      gsTypeList: [],
      makeUnitList: [],
      custodyTypeList: []
    })
    useGetData(cylinderPreAdd, (data) => {
      for (const key in data) {
        selectValues[key] = data[key]
      }
    })({ companyId: companyId.value })

    // 表单内picker值
    const formValues = reactive({
      gsType: '',
      gsTypeName: '',
      gsMedium: '',
      makeUnit: '',
      makeDate: '',
      checkDate: '',
      nextCheckDate: '',
      companyId: companyId,
      gsCapacity: '',
      gsId: '',
      regId: '',
      gsStatus: '',
      tagId: '',
      belongUnit: '',
      gsPressure: '',
      makeUnitName: '',
      gsGoodsName: '',
      gsCapacityName: '',
      custodyFlagName: '',
      custodyFlag: '',
      cyWeight: ''
    })
    formValues.regId = ''
    formValues.gsId = ''
    formValues.gsStatus = ''
    formValues.tagId = ''
    const changeUnit = (values) => {
      formValues.makeUnit = values.dicVal
      formValues.makeUnitName = values.dicValMean
    }
    const changeMedium = (values) => {
      formValues.gsMedium = values.dicVal
      formValues.gsGoodsName = values.dicValMean
    }
    const form = ref(null) // dom

    // 点击提交按钮
    const handleSubmitClick = () => {
      form.value.submit()
    }
    const loading = ref(false) // 按钮加载状态
    const clickAble = ref(false)
    // 表单验证通过执行
    const router = useRouter()
    const submitValues = (values) => {
      const numList = ['gsThickness', 'gsPressure']
      numList.forEach((item) => {
        values[item] = Number(values[item])
      })
      const params = {
        ...formValues, // 表单内picker值
        ...values, // 表单内input值
        url: imgPath.value // 图片url
      }

      // 执行提交表单接口
      loading.value = true
      cylinderAdd(params)
        .then(() => {
          loading.value = false
          router.push('/cylinderManageUserHome')
          Notify({ type: 'success', message: '操作成功' })
        })
        .catch(() => {
          loading.value = false
        })
    }
    // 钢瓶容量
    const gsCapacityList = [
      { value: 4, dicValMean: '4L' },
      { value: 4.2, dicValMean: '4.2L' },
      { value: 11, dicValMean: '11L' },
      { value: 20, dicValMean: '20L' },
      { value: 25, dicValMean: '25L' },
      { value: 30, dicValMean: '30L' },
      { value: 35, dicValMean: '35L' },
      { value: 35.5, dicValMean: '35.5L' },
      { value: 38.3, dicValMean: '38.3L' },
      { value: 40, dicValMean: '40L' },
      { value: 50, dicValMean: '50L' },
      { value: 72, dicValMean: '72L' },
      { value: 118, dicValMean: '118L' },
      { value: 175, dicValMean: '175L' },
      { value: 195, dicValMean: '195L' },
      { value: 210, dicValMean: '210L' },
      { value: 400, dicValMean: '400L' },
      { value: 450, dicValMean: '450L' },
      { value: 495, dicValMean: '495L' },
      { value: 800, dicValMean: '800L' }
    ]
    // 文件上传
    const fileList = ref([])
    const imgPath = computed(() => {
      const arr = []
      fileList.value.forEach((item) => {
        if (item.status === 'done') {
          arr.push(item.content || item.url)
        }
      })
      return arr[0] || ''
    })
    const afterRead = (file) => {
      getImgFile(file, fileList)
    }
    /**
     * 添加钢瓶编号监听校验
     */
    const asyncValidator = (obj) => {
      if (!obj.value) return
      cylinderDetail(obj.value)
        .then((res) => {
          if (res.status === 200) {
            clickAble.value = true
            formValues.regId = res.data.regId
            formValues.gsType = res.data.gsType
            formValues.gsId = res.data.gsId
            formValues.gsStatus = res.data.gsStatusName
            formValues.gsPressure = res.data.gsPressure + ''
            formValues.belongUnit = res.data.belongUnit
            formValues.tagId = res.data.tagId
            if (!res.data.makeUnit) {
              console.log(44)
              formValues.makeUnitName = ''
            } else {
              formValues.makeUnitName = res.data.makeUnitName
            }
            formValues.makeUnit = res.data.makeUnit
            formValues.nextCheckDate = res.data.nextCheckDate
            formValues.makeDate = res.data.makeDate
            formValues.checkDate = res.data.checkDate
            if (!res.data.gsMedium) {
              console.log(444)
              formValues.gsGoodsName = ''
            } else {
              formValues.gsGoodsName = res.data.gsGoodsName
            }
            formValues.gsMedium = res.data.gsMedium
            formValues.gsCapacity = res.data.gsCapacity
            formValues.gsCapacityName = res.data.gsCapacity + 'L'
            formValues.gsTypeName = res.data.gsTypeName
            formValues.custodyFlagName = res.data.custodyFlagName
          } else {
            formValues.regId = ''
            // formValues.gsType = ''
            formValues.gsId = ''
            formValues.gsStatus = ''
            // formValues.gsPressure = ''
            // formValues.belongUnit = ''
            formValues.tagId = ''
            // formValues.makeUnitName = ''
            // formValues.nextCheckDate = ''
            // formValues.makeDate = ''
            // formValues.checkDate = ''
            // formValues.gsGoodsName = ''
            // formValues.gsCapacity = ''
            // formValues.gsCapacityName = ''
            // formValues.gsTypeName = ''
            // formValues.custodyFlagName = ''
            clickAble.value = false
          }
        })
        .catch(() => {
          clickAble.value = false
        })
    }
    const formatter = (value) => value.replace(/\s+/g, '')
    return {
      ...toRefs(formValues),
      ...toRefs(selectValues),
      submitValues,
      form,
      handleSubmitClick,
      loading,
      gsCapacityList,
      imgPath,
      afterRead,
      fileList,
      asyncValidator,
      clickAble,
      changeUnit,
      changeMedium,
      formatter
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: 16px;
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
